import { ApiParameter, get } from "@insite/client-framework/Services/ApiService";
import { BaseModel } from "@insite/client-framework/Types/ApiModels";

const getVisualNavigationManagerUrl = "/api/v1/visualnavigation/GetAllVisualNavFilters";

export interface VisualNavigationManagerParameter extends ApiParameter { }

export interface VisualNavigationManagerModel extends BaseModel {
    id?: string;
    categoryName: string;
    subCategoryName: string;
    visualFilters: VisualFilterModel[];
    pathUrl: string;
    fromDate: string;
    toDate: string;
    isAdminView: boolean;
    siteName: string;
}

interface VisualFilterModel {
    visualFilterID: string;
    categoryID: string;
    filterTitle: string;
    productNumber: string;
    productImage: string;
    attributeFilters: string;
    pageURL: string;
    sort: string;
    pageSize: string;
    boostIDs: string;
    searchWithin: string;
    expand: string;
    isDisabled: boolean;
    isToBeAdded: boolean;
    class: string;
    style: string;
    dataGaPromo: string;
    visualNavType: number;
}

export async function getVisualNavigationManagerDetails(parameter: VisualNavigationManagerParameter): Promise<VisualNavigationManagerModel> {
    const getVisualNavigationManager = await get<VisualNavigationManagerModel>(`${getVisualNavigationManagerUrl}`);
    return getVisualNavigationManager;
}